// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__36iYx","title":"BackImages_title__1bbWp","images":"BackImages_images__-8oj0"};